var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIconReload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7745 6.81402H18V1.57848H16.1991V3.63667C15.6144 2.84633 14.9065 2.16116 14.0872 1.59347C12.5831 0.55098 10.8181 0 8.98284 0C6.58345 0 4.32781 0.93608 2.63093 2.6362C0.93405 4.33608 0 6.59604 0 9C0 11.404 0.93405 13.6642 2.63093 15.364C4.32781 17.0639 6.58345 18 8.98283 18C11.3822 18 13.6379 17.0639 15.3347 15.364C17.0316 13.6642 17.9657 11.404 17.9657 9V8.78423H16.1653V9C16.1653 12.9677 12.9432 16.1959 8.98283 16.1959C5.02245 16.1959 1.80039 12.9677 1.80039 9C1.80039 5.0323 5.02246 1.80408 8.98283 1.80408C11.4283 1.80408 13.6369 2.99525 14.9653 5.00994H12.7744V6.81402H12.7745Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconReload);
export default __webpack_public_path__ + "static/media/nav_icon_reload.95ca136a9cb8a021d9abd927cdb29051.svg";
export { ForwardRef as ReactComponent };